export default __webpack_public_path__ + "static/media/background.e5f51f5e.png";